// action type for Notification

// get notification Open List
export const GET_NOTIFICATION_OPEN_LIST = "GET_NOTIFICATION_OPEN_LIST";
export const GET_NOTIFICATION_OPEN_LIST_SUCCESS =
  "GET_NOTIFICATION_OPEN_LIST_SUCCESS";
export const GET_NOTIFICATION_OPEN_LIST_ERROR =
  "GET_NOTIFICATION_OPEN_LIST_ERROR";
///system/notification/internal/send
export const SYSTEM_NOTIFICATION_INTERNAL_SEND =
  "SYSTEM_NOTIFICATION_INTERNAL_SEND";
export const SYSTEM_NOTIFICATION_INTERNAL_SEND_SUCCESS =
  "SYSTEM_NOTIFICATION_INTERNAL_SEND_SUCCESS";
export const SYSTEM_NOTIFICATION_INTERNAL_SEND_ERROR =
  "SYSTEM_NOTIFICATION_INTERNAL_SEND_ERROR";
